import { UseCase } from './UseCase';
export class StopAutoplayUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.autoplay.configureNextAutoPlay(0)
            .then(() => this.applicationServices.interface.disableAutoplay())
            .catch(error => Promise.reject(error));
    }
}
